const WHAT_IS_SOLIDAY_EURO_CARDS = [{
  name: 'donation',
  class: 'stars',
  textLineOne: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DONATION_CARD.TITLE',
  textLineTwo: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DONATION_CARD.LINE_ONE',
},
{
  name: 'descount',
  class: 'descountStars',
  textLineOne: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DESCOUNT_CARD.TITLE',
  textLineTwo: 'SOLIDARITY.WHAT_IS_SOLIDARY_EURO.DESCOUNT_CARD.LINE_ONE',
},

];

const COOKIES = {
  WHAT_IS_SOLIDARY_EURO: 'dontshowsolidaryconcept',
};

const SOLIDARITY_STATES = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  FAILED: 'failed',
  ACCEPT: 'accept',
  QUESTION_ACCEPT: 'questionAcept',
  QUESTION_CANCEL: 'question',
  CANCEL: 'cancel',
  DELETED: 'deleted',
  FAILED_CANCELATION: 'cancelationfailed',
};

const SOLIDARITY_QUESTION_SETTINGS = [
  {
    text: 'GLOBALS.BUTTON_ACTION.ACCEPT',
    value: 'cancel',
  },
];

const SOLIDARITY_QUESTION_ACCEPT = [
  {
    text: 'GLOBALS.BUTTON_ACTION.ACCEPT',
    value: 'accept',
  },
];

export {
  WHAT_IS_SOLIDAY_EURO_CARDS,
  COOKIES,
  SOLIDARITY_STATES,
  SOLIDARITY_QUESTION_SETTINGS,
  SOLIDARITY_QUESTION_ACCEPT
};



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/domain/constants.js